export default __webpack_public_path__ + "static/media/green-edit.c15e8326.svg";